import axios from 'axios'

let defaultOptions = {
  baseURL: `https://vmestemcpb.ru:8085/api/v1/`,
  // baseURL: `https://${document.domain}:8085/api/v1/`,
  // baseURL: 'https://app.test.vmestemcpb.ru:8085/api/v1/',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const api = axios.create(defaultOptions);
